export enum ReportActionTypes {
    API_RESPONSE_SUCCESS = '@@report/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@report/API_RESPONSE_ERROR',

    ADD_REPORT = '@@report/ADD_REPORT',
    EDIT_REPORT = '@@report/EDIT_REPORT',
    GET_REPORT = '@@report/GET_REPORT',
    GET_REPORTS = '@@report/GET_REPORTS',
    GET_VALIDATE_REPORT = '@@report/GET_VALIDATE_REPORT',
    GET_SERVICE_REPORT = '@@report/GET_SERVICE_REPORT',
    GET_SALES_REPORT = '@@report/GET_SALES_REPORT',
    GET_OBSERVATION_REPORT = '@@report/GET_OBSERVATION_REPORT',
    RESET = '@@report/RESET',
    RESET_SUCCESS = '@@report/RESET_SUCCESS',
    RESET_ERROR = '@@report/RESET_ERROR',
}
